export default __webpack_public_path__ + "static/media/151-real-estate-1.e02f4dd0.png";